import React, { FC } from 'react';
import { Title } from '../page-components/Title';
import { toAbsoluteUrl } from '../../../utils';
import { useTranslation } from 'react-i18next';
import { copyTextToClipboard } from '../../../utils/utilities';
import { toaster } from 'rsuite';
import toastMessage from '../../ToastMessage';
import { useMerchants } from '../../../store/merchnts/merchants-context';

export const SFTPPublicKey: FC = () => {
	const { t } = useTranslation();
	const { merchantState: { sftpConfig }} = useMerchants();

	const copyKey = async (): Promise<void> => {
		await copyTextToClipboard(sftpConfig?.password);
		toaster.push(toastMessage({
			text: `${t('SFTP.PASSWORD')} ${t('API_KEY.TOAST_MESSAGE')}`,
			type: 'success'
		}), { placement: 'topEnd' });
	};

	return (
		<>
			<Title title={t('SFTP.PASSWORD')} additionalClass="fw-bolder fs-4 mb-5"/>
			<div className="row justify-content-between mb-5">
				<div className="col-9 col-sm-10 col-md-9 col-xxl-10">{sftpConfig?.password}</div>
				<div
					className="icon-copy cursor-pointer col-3 col-sm-2 col-md-3 col-xxl-2 text-end"
					onClick={copyKey}
				>
					<img src={toAbsoluteUrl('/media/icons/copy.svg')} width="12px" height="15px" alt="copy"/>
					<span className="text-danger fw-bolder fs-6 ms-2 me-2 me-md-1 me-xxl-2">
            {t('SENSE_JS.COPY')}
          </span>
				</div>
			</div>
			{/*<div className="text-muted fs-7">{t('SFTP.LABEL_TEXT')}</div>*/}
		</>
	);
};
